export default __webpack_public_path__ + "static/media/cpplogo.40a579ca.png";